import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ProcessType } from "@shared/DTO/processType";
import { WarpProcessRequest } from "@shared/DTO/warpProcessRequest";
import { WarpService } from "@shared/services/warp.service";

@Component({
  selector: "app-enrollment-button",
  templateUrl: "./enrollment-button.component.html",
  styleUrls: ["./enrollment-button.component.scss"],
})
export class EnrollmentButtonComponent
{
  @Input() processType: ProcessType;
  @Input() recognitionType: string;
  @Input() userId: string;
  @Input() isAccountSelected: boolean;
  @Output() enrollmentEvent: EventEmitter<WarpProcessRequest> =
    new EventEmitter();
  recSelected: any;
  currentLang: string;
  @Input() isOutOfStock: boolean;

  constructor(
    private translateService: TranslateService,
    private warpService: WarpService
  ) {
    this.currentLang = this.translateService.currentLang;
  }

  initEnrollment() {
    if (this.processType === ProcessType.ENROLLMENT)
      this.enrollmentEvent.emit(
        this.warpService.buildWarpProcessRequest(ProcessType.ENROLLMENT,this.currentLang, this.recognitionType, this.userId, this.recSelected)
      );
    else if (this.processType === ProcessType.CSVENROLLMENT)
      this.enrollmentEvent.emit(
        this.warpService.buildWarpProcessRequest(ProcessType.CSVENROLLMENT,this.currentLang, this.recognitionType, this.userId, this.recSelected)
      );
  }

}
